import React from "react";
import { Accordion } from "@mantine/core";
import { useTheme } from "styled-components";
const getStyles = (theme, options) => ({
  root: {
    width: "100%"
  },
  item: {
    backgroundColor: options.noBackground ? "transparent" : theme.colors.background.body,
    borderRadius: theme.spacings.xs
  }
});
const MantineAccordion = ({
  accordionItems,
  defaultValue,
  chevronPosition = "left",
  variant = "default",
  noBackground = false,
  ...mantineProps
}) => {
  const theme = useTheme();
  const styles = getStyles(theme, { noBackground });
  const items = accordionItems.map((item) => /* @__PURE__ */ React.createElement(Accordion.Item, { key: item.value, value: item.value }, /* @__PURE__ */ React.createElement(Accordion.Control, null, item.label), /* @__PURE__ */ React.createElement(Accordion.Panel, null, item.content)));
  return /* @__PURE__ */ React.createElement(
    Accordion,
    {
      styles,
      variant,
      chevronPosition,
      defaultValue,
      ...mantineProps
    },
    items
  );
};
export default MantineAccordion;
